import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContextProvider";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {
  const {
    isAuthenticated,
    loading,
    setToken,
    setName,
    setEmail,
    setUserId,
    setIsAuthenticated,
  } = useAuth();

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const userName = sessionStorage.getItem("userName");
    const userEmail = sessionStorage.getItem("userEmail");
    const userId = sessionStorage.getItem("userId");

    if (token) {
      setToken(token);
      setName(userName);
      setEmail(userEmail);
      setUserId(userId);
      setIsAuthenticated(true);
    }
  }, [setToken, setName, setEmail, setUserId, setIsAuthenticated]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
